import styled from '@emotion/styled';

export const StyledReportWrap = styled.div`
  margin-top: 15px;
`;

export const StyledReportArea = styled.div`
  display: flex;
  min-width: 1000px;
  align-items: center;
  background: #fff;
  margin-bottom: 10px;
  padding: 20px 40px;
  & > strong {
    position: relative;
    display: block;
    height: 24px;
    width: 203px;
    font-size: 16px;
    line-height: 23px;
    color: #333;
  }
`;

export const StyledReportFlex = styled.div`
  margin-left: 9px;
  margin-right: 23px;
  border-left: 1px solid #e0e0e0;

  position: relative;
  padding-left: 32px;
  color: #000;

  & .flex-box {
    display: flex;
    align-items: center;
    margin-bottom: 11px;
    gap: 19px;

    & > .color-map-title {
      width: 150px;
    }
  }
`;
